import { render } from "./PhysicalStandard.vue?vue&type=template&id=40db5730&scoped=true"
import script from "./PhysicalStandard.vue?vue&type=script&lang=js"
export * from "./PhysicalStandard.vue?vue&type=script&lang=js"

import "./PhysicalStandard.vue?vue&type=style&index=0&id=40db5730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40db5730"]])

export default __exports__